import React from "react";
import ReactInputMask from "react-input-mask";
import { FormControl } from "react-bootstrap";

export default function MaskedFormControl(props) {
  return <FormControl as={ReactInputMask} {...props} />;
} 